<template>
  <div class="share-to-messengers">
    <div v-if="title"
         class="share-to-messengers__title">
      {{ title }}
    </div>
    <div class="share-to-messengers__list">
      <a :href="viberLink"
         target="_blank"
         class="share-to-messengers__link  _viber">
        <BaseSvg name="ico-viber"/>
      </a>
      <a :href="telegramLink"
         target="_blank"
         class="share-to-messengers__link  _telegram">
        <BaseSvg name="ico-telegram"/>
      </a>
      <button @click.prevent="shareFB"
         class="share-to-messengers__link  _messenger">
        <BaseSvg name="ico-messenger"/>
      </button>

      <slot name="append-list"></slot>

<!--      <div id="fb-root"></div>-->

<!--      <div class="fb-share-button">-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ShareToMessengers',
    props: {
      title: String,
      message: String,
      customLink: String,
      customLinks: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      link() {
        return this.customLink || window.location.href
      },
      viberLink() {
        return `viber://forward?&text=${this.message || ''} \n ${this.customLinks.viber || this.link}`
      },
      telegramLink() {
        return `https://t.me/share/url?url=${this.customLinks.telegram || this.link}&text=${this.message || ''}`
      },
    },
    methods: {
      shareFB() {
        var obj = {
          method: 'feed',
          link: this.customLinks.facebook || getMetaOG('og:url'),
          picture: getMetaOG('og:image'),
          name: getMetaOG('og:title'),
          description: this.message || getMetaOG('og:description')
        };

        FB.ui(obj);
      }
    },
    mounted() {
      window.fbAsyncInit = function () {
        FB.init({
            //327782288819225
          appId: '185567417108736', status: true, cookie: true, xfbml: true
        });
      };

      (function (d, debug) {
        var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement('script');
        js.id = id;
        js.async = true;
        js.src = "//connect.facebook.net/en_US/all" + (debug ? "/debug" : "") + ".js";
        ref.parentNode.insertBefore(js, ref);
      }(document, /*debug*/ false));
    }
  }

  function getMetaOG(name) {
    const el = document.querySelector(`meta[property="${name}"]`)
    if(!el) return null
    return el.getAttribute('content')
  }
</script>

<style lang="less">

</style>
